export default __webpack_public_path__ + "static/media/sandal7.3278b5a1.jpeg";